/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { userIndex } from '../../axios/userIndex'
import type { UserIndexError, UserIndexQueryParams, UserIndexResponse } from '../../types/UserIndex'

export const userIndexQueryKey = (params?: UserIndexQueryParams) =>
	[{ url: '/users' }, ...(params ? [params] : [])] as const

export type UserIndexQueryKey = ReturnType<typeof userIndexQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::index */
export function userIndexQueryOptions(params?: UserIndexQueryParams, config?: AxiosRequestConfig) {
	return queryOptions<UserIndexResponse, AxiosError<UserIndexError>, UserIndexResponse, UserIndexQueryKey>({
		queryKey: userIndexQueryKey(params),
		queryFn: ({ signal }) => userIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::index */
export function useUserIndex<TSelectData = UserIndexResponse>(
	params?: UserIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<UserIndexResponse, AxiosError<UserIndexError>, TSelectData, UserIndexQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<UserIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...userIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::index */
export function useUserIndexSuspense<TSelectData = UserIndexResponse>(
	params?: UserIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<UserIndexResponse, AxiosError<UserIndexError>, TSelectData, UserIndexQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<UserIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...userIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
